import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PlayerAvatar } from "./PlayerAvatar";
import { Star } from "lucide-react";

const PLACES = [
  { ring: "border-amber-400/60 bg-amber-400/10", label: "text-amber-300", h: "sm:pt-0" },
  { ring: "border-slate-300/40 bg-slate-300/5", label: "text-slate-300", h: "sm:pt-6" },
  { ring: "border-orange-500/40 bg-orange-500/5", label: "text-orange-300", h: "sm:pt-10" },
];

export function MatchdayPagella({ playersMap, onSelectPlayer }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/votes/matchday-top").then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data?.has_data) return null;
  const dateFmt = (() => {
    try { return new Date(data.date).toLocaleDateString("it-IT", { day: "numeric", month: "long" }); }
    catch { return data.date; }
  })();

  return (
    <div className="ap-card p-5 space-y-4" data-testid="matchday-pagella">
      <div className="flex items-center gap-2">
        <Star className="w-4 h-4 text-amber-400 fill-amber-400" />
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-400">Pagella della giornata</span>
        <span className="ml-auto text-xs text-slate-500" data-testid="matchday-pagella-title">
          Giornata {data.matchday}{dateFmt ? ` · ${dateFmt}` : ""}
        </span>
      </div>
      <div className="grid gap-3 sm:grid-cols-3 items-start">
        {data.top.map((r, i) => (
          <button
            key={r.player_id}
            data-testid={`matchday-pagella-${i + 1}`}
            onClick={() => onSelectPlayer(r.player_id)}
            className={`${PLACES[i].h} text-left`}
          >
            <div className={`rounded-2xl border p-4 flex items-center gap-3 transition-transform hover:-translate-y-0.5 ${PLACES[i].ring}`}>
              <span className={`font-display font-black text-2xl ${PLACES[i].label}`}>{i + 1}°</span>
              <PlayerAvatar id={r.player_id} name={playersMap[r.player_id]?.name} size={40} />
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold text-white truncate">{playersMap[r.player_id]?.name}</div>
                <div className="text-[11px] text-slate-500">{r.count} {r.count === 1 ? "voto" : "voti"}</div>
              </div>
              <span className="font-mono font-black text-xl text-amber-400">{r.avg.toFixed(1)}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
